import {LOAD_POLICENOTICE_DATA, DELETE_A_POLICENOTICE, SAVE_A_POLICENOTICE, UPDATE_A_POLICENOTICE, UPDATE_A_POLICENOTICE_PATH} from './actions';

const initialState = {
  policenoticesArray:[],
    deletePolicenoticeResp:{},
    errorCMsg:{},
    savePolicenoticeResp:{},
    updatePolicenoticeResp:{},
    policeNoticePath:"",
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case LOAD_POLICENOTICE_DATA:
          return Object.assign({}, state, {
              policenoticesArray: action.policenoticesData
          });
          case DELETE_A_POLICENOTICE:
          return Object.assign({}, state, {
              deletePolicenoticeResp: action.deletePolicenoticeResponse,
              errorCMsg: action.errorMsg
          });
      case SAVE_A_POLICENOTICE:
          return Object.assign({}, state, {
              savePolicenoticeResp: action.savePolicenoticeResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_POLICENOTICE:
          return Object.assign({}, state, {
              updatePolicenoticeResp: action.updatePolicenoticeResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_POLICENOTICE_PATH:
          return Object.assign({}, state, {
              policeNoticePath: action.filePath,
              errorCMsg: action.errorMsg
          });

    default:
      return state;
  }
}
